module.exports = __webpack_public_path__ + "img/Rectangle 927.d956da45.svg";